import { Heading } from 'components/text';
import { FC, useCallback, useState } from 'react';
import styles from './Faq.module.scss';
import Container from 'components/container';
import FaqAccordion from './FaqAccordion';
import { MylerFAQ, MylerFAQs } from '../contants';
import { colorConstants } from 'data/constants';

type IFaq = {
  handleOpenEnquiryForm: () => void;
};

const LastFAQ = (handleClick: () => void): MylerFAQ => {
  return {
    expanded: false,
    title: 'How do I become a MyLER?',
    text: (
      <span>
        Just complete our form{' '}
        <span className={styles.enquiryFormLink} onClick={handleClick}>
          here
        </span>{' '}
        to let us know you’d like to become an Independent Travel Agent and a
        member of our team will be in touch.
      </span>
    ),
  };
};

const Faq: FC<IFaq> = ({ handleOpenEnquiryForm }) => {
  const [expandedPanelId, setExpandedPanelId] = useState<string | null>(null);

  const lastFAQ = LastFAQ(handleOpenEnquiryForm);

  const handleAccordionChange = useCallback(
    (id: string) => {
      if (expandedPanelId !== null && expandedPanelId === id) {
        setExpandedPanelId(null);
      } else {
        setExpandedPanelId(id);
      }
    },
    [expandedPanelId]
  );
  return (
    <Container className={styles.container} id="faqs" as="section">
      <Heading as="h4" align="center">
        FAQs
      </Heading>
      <Container className={styles.faqList}>
        {[...MylerFAQs, lastFAQ].map((faq, index) => {
          return (
            <FaqAccordion
              title={faq.title}
              text={faq.text}
              expanded={expandedPanelId === index.toString()}
              id={index.toString()}
              key={index}
              handleChange={handleAccordionChange}
              sx={{
                borderBottom: 1,
                borderColor: colorConstants.brandColor,
                '& .MuiAccordionSummary-content': {
                  fontWeight: 500,
                },
              }}
            />
          );
        })}
      </Container>
    </Container>
  );
};

export default Faq;
